export const DAO_CODE = 'EXPENSE' + 'TYPE' + '_DAO';
